import { Carte, Chargement, MessageErreur, Pastille } from '../ui/Primitives';
import { BlocsEcf } from '../ecf/BlocsEcf';
import { useEcfDossier } from '../../lib/useEcf';
import { ErreurApi } from '../../lib/api';

/**
 * ECF du dossier, bloc par bloc (CDC §7.5) : ce que l'équipe a besoin de savoir
 * avant l'examen — ce qui est évalué, acquis, et ce qui reste. La carte lit la
 * saisie de l'écran « Fin de formation & ECF », elle ne tient aucun compteur.
 */
export function CarteEcf({ apprenantId }: { apprenantId: string }): JSX.Element | null {
  const { data, isLoading, error } = useEcfDossier(apprenantId);

  if (isLoading) {
    return (
      <Carte titre="ECF" sansBordure>
        <Chargement libelle="Lecture des ECF…" />
      </Carte>
    );
  }
  if (error) {
    return (
      <Carte titre="ECF" sansBordure>
        <div className="p-4 sm:p-6">
          <MessageErreur
            message={error instanceof ErreurApi ? error.message : 'Les ECF n’ont pas pu être chargées.'}
          />
        </div>
      </Carte>
    );
  }
  // Une formation sans ECF au programme, et rien d'évalué : la carte n'a rien
  // à dire — elle ne s'affiche pas plutôt que de répéter le motif à chaque dossier.
  if (!data || (!data.auProgramme && data.blocs.length === 0)) return null;

  const { bilan } = data;
  return (
    <Carte
      titre="Évaluations en cours de formation (ECF)"
      actions={
        bilan ? (
          <>
            <Pastille
              texte={`${bilan.realisees}/${bilan.attendues} réalisée${bilan.realisees > 1 ? 's' : ''}`}
              ton={bilan.restantes === 0 ? 'success' : 'info'}
            />
            <Pastille
              texte={`${bilan.acquises} acquise${bilan.acquises > 1 ? 's' : ''}`}
              ton={bilan.acquises === bilan.attendues ? 'success' : 'neutral'}
            />
          </>
        ) : undefined
      }
      sansBordure
    >
      <div className="space-y-3 p-4 sm:p-6">
        {!data.auProgramme && <p className="text-sm text-codialis-gray">{data.motif}</p>}
        <BlocsEcf blocs={data.blocs} />
      </div>
    </Carte>
  );
}
